export default __webpack_public_path__ + "static/char-v-32-723ddf73276c6b88d02799d4cdf2e43f.png";